<rotec-modal-v2
  [title]="modalTitle"
  [translateTitle]="false"
  [hideModalTitle]="true"
  [disablePaddingMainPart]="true"
  [darkMode]="true"
  width="80vw"
  height="95vh"
  #modal
>
  <ng-container ngProjectAs="modal-main">
    <ma-task-modal-main [taskInfos]="taskInfos" [assetPictureId]="assetPictureId">
      <ma-task-status></ma-task-status>

      <ma-task-info [task]="task" [details]="details"></ma-task-info>

      @if (task) {
        <h3 translate>History</h3>
        @for (shifting of task.shiftings; track shifting) {
          <h4>
            {{
              'Shifted at DATE to NEWDUEDATE'
                | translate
                  : {
                      date: shifting.timeStamp | localizedDate: 'shortDate',
                      newDueDate: shifting.shiftedDueDate | localizedDate: 'shortDate',
                    }
            }}
          </h4>
          <p>{{ shifting.shiftReason }}</p>
        }
        <h4 translate>
          {{
            (task.executionDate ? 'Finished at DATE' : 'Skipped at DATE')
              | translate
                : {
                    date:
                      (task.executionDate ? task.finishInfo.timeStamp : task.skipInfo.timeStamp)
                      | localizedDate: 'shortDate',
                  }
          }}
        </h4>
        <p>{{ task.executionDate ? task.finishInfo.finishReason : task.skipInfo.skipReason }}</p>
        @if (userRightsService.hasActionRights$('Add') | async) {
          <ma-task-documents
            [documentIds]="task.taskDocumentIds"
            [documentsLoading]="taskModalService.taskLoading$ | async"
            (documentIdsChange)="setDocuments($event)"
          ></ma-task-documents>
        }
      }
    </ma-task-modal-main>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-secondary dark (click)="close()">{{ 'Cancel' | translate }}</button>
    @if (userRightsService.hasActionRights$('Add') | async) {
      <button rotec-button-primary-v2 dark [disabled]="isUndoBtnDisabled" (click)="undo()">
        {{ 'Reactivate' | translate }}
      </button>
    }
  </ng-container>
</rotec-modal-v2>
